module.exports = {
  OperationFailed: 'Ошибка операции',
  SelectTime: 'Выберите время',
  FeeRefund: '(Возврат пошлины)',
  TheHasExpiredNoCreated: 'Договор с данной доверенной организацией истёк, создание операций невозможно',
  DueCannotBePrintedNeeded: 'Из-за превышения кредитного лимита вексель заблокирован, печать и EDI недоступны. Для разблокировки обратитесь к руководству!',
  ItPrintedPleaseContactUnlock: 'Заблокировано, печать невозможна. Обратитесь к руководителю для разблокировки!',
  AttachmentContentIsTooLarge: 'Слишком большой объём вложения',
  Unknown: 'Неизвестно',
  YourWeightAndVolumeTo: 'Ваш груз уже участвовал в сверке данных. Автоупаковка обновит информацию о количестве/весе/объёме в этом и основном коносаментах.',
  Tip: 'Уведомление',
  GotIt: 'Понятно',
  AddNew: 'Добавить',
  PleaseSelectTheSpecifiedData: 'Выберите указанные данные',
  LicenseOfLadingNumberEmpty: 'Номер машины и номер коносамента обязательны для заполнения',
  IntegratedLogisticsCargoDetails: 'Детализация груза комплексной логистики',
  PleaseAPieceOfData: 'Выберите одну запись!',
  Mbl: 'Номер CMR'
}
